// Shared brand data — single source of truth for both apps. Generated/maintained;
// edit here, not the per-app overlays. APP_BUNDLES carries exam_name/exam_code (mobile
// reads them; web ignores). See docs/app-constant-usage-audit.md.
export const APP_BUNDLES = [
    {
      title: 'A+ 220-1201 (Core 1)',
      key: '220-1201',
      description: 'CompTIA A+ Core 1',
      exam_name: 'A+ Core 1',
      exam_code: '220-1201',
      bundle_firebase_collection_name: 'COMPTIA_A_220_1201',
    },
    {
      title: 'A+ 220-1202 (Core 2)',
      key: '220-1202',
      description: 'CompTIA A+ Core 2',
      exam_name: 'A+ Core 2',
      exam_code: '220-1202',
      bundle_firebase_collection_name: 'COMPTIA_A_220_1202',
    },
    {
      title: 'Cloud+ CV0-004',
      key: 'Cloud+',
      description: 'CompTIA Cloud+',
      exam_name: 'Cloud+',
      exam_code: 'CV0-004',
      bundle_firebase_collection_name: 'COMPTIA_CLOUD_CV0_004',
    },
    {
      title: 'CySA+ CS0-003',
      key: 'CySA+',
      description: 'CompTIA Cybersecurity Analyst',
      exam_name: 'CySA+',
      exam_code: 'CS0-003',
      bundle_firebase_collection_name: 'COMPTIA_CYSA_CS0_003',
    },
    {
      title: 'DataSys+ DS0-001',
      key: 'DataSys+',
      description: 'CompTIA DataSys+',
      exam_name: 'DataSys+',
      exam_code: 'DS0-001',
      bundle_firebase_collection_name: 'COMPTIA_DATASYS_DS0_001',
    },
    {
      title: 'DataX DX0-001',
      key: 'DATAX',
      description: 'CompTIA DataX',
      exam_name: 'DataX',
      exam_code: 'DX0-001',
      bundle_firebase_collection_name: 'COMPTIA_DATAX_DX0_001',
    },
    {
      title: 'Linux+ XK0-006',
      key: 'Linux+',
      description: 'CompTIA Linux+',
      exam_name: 'Linux+',
      exam_code: 'XK0-006',
      bundle_firebase_collection_name: 'COMPTIA_LINUX_XK0_006',
    },
    {
      title: 'Network+ N10-009',
      key: 'Network+',
      description: 'CompTIA Network+',
      exam_name: 'Network+',
      exam_code: 'N10-009',
      bundle_firebase_collection_name: 'COMPTIA_NETWORK_N10_009',
    },
    {
      title: 'PenTest+ PT0-003',
      key: 'PenTest+',
      description: 'CompTIA PenTest+',
      exam_name: 'PenTest+',
      exam_code: 'PT0-003',
      bundle_firebase_collection_name: 'COMPTIA_PENTEST_PT0_003',
    },
    {
      title: 'Project+ PK0-005',
      key: 'Project+',
      description: 'CompTIA Project+',
      exam_name: 'Project+',
      exam_code: 'PK0-005',
      bundle_firebase_collection_name: 'COMPTIA_PROJECT_PK0_005',
    },
    {
      title: 'Security+ SY0-701',
      key: 'Security+',
      description: 'CompTIA Security+',
      exam_name: 'Security+',
      exam_code: 'SY0-701',
      bundle_firebase_collection_name: 'COMPTIA_SECURITY_SY0_701',
    },
    {
      title: 'Server+ SK0-005',
      key: 'Server+',
      description: 'CompTIA Server+',
      exam_name: 'Server+',
      exam_code: 'SK0-005',
      bundle_firebase_collection_name: 'COMPTIA_SERVER_SK0_005',
    }
  ]

export const EXAM_TITLES = {
  '220-1201': 'A+ 220-1201',
  '220-1202': 'A+ 220-1202',
  'Cloud+': 'Cloud+ CV0-004',
  'CySA+': 'CySA+ CS0-003',
  'DataSys+': 'DataSys+ DS0-001',
  'DATAX': 'DataX DX0-001',
  'Linux+': 'Linux+ XK0-006',
  'Network+': 'Network+ N10-009',
  'PenTest+': 'PenTest+ PT0-003',
  'Project+': 'Project+ PK0-005',
  'Security+': 'Security+ SY0-701',
  'Server+': 'Server+ SK0-005'
}

export const BUNDLE_APP_NAME = "COMPTIA_BUNDLE";

export const IS_BUNDLE_APP = true;
